import { useEffect, useState } from "react"
import {
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Paper,
  Stack,
  Typography,
  LinearProgress,
  Grid2,
  Grow,
  Box
} from "@mui/material"
import "../../styles/terminals.styles.scss"
import "../../../../../styleSheets/base/styles.scss"
import api from "../../../../../base/services/ResApi"
import activeTerminal from "../../../../../../resources/activeTerminal.png"
import inactiveTerminal from "../../../../../../resources/inactiveTerminal.png"
import devicelock from "../../../../../../resources/devicelock.png"
import deviceunlocked from "../../../../../../resources/deviceunlocked.png"
import search from "../../../../../../resources/search.png"
import supply from "../../../../../../resources/supply.png"
import battery from "../../../../../../resources/battery2.png"
import switch_1 from "../../../../../../resources/switch (1).png"
import phone from "../../../../../../resources/phone.png"
import time from "../../../../../../resources/time.png"
import schedule from "../../../../../../resources/schedule.png"
import memory from "../../../../../../resources/memory.png"
import storage from "../../../../../../resources/server-storage.png"
import matrics_1 from "../../../../../../resources/metrics (1).png"
import touch from "../../../../../../resources/touch.png"
import usb from "../../../../../../resources/usb-connection.png"
import connection from "../../../../../../resources/connection.png"
import operatorInfo from "../../../../../../resources/operatorInfo.png"
import simName from "../../../../../../resources/simName.png"
import signal from "../../../../../../resources/signal.png"
import simSerial from "../../../../../../resources/simSerial.png"
import ipAddress from "../../../../../../resources/ipAddress.png"
import wifi from "../../../../../../resources/wifi.png"
import gateway from "../../../../../../resources/gateway.png"
import networking from "../../../../../../resources/networking.png"
import dns from "../../../../../../resources/dns.png"
import location from "../../../../../../resources/location.png"

import { FetchErrorHandeling } from "../../../../../base/errorHandeling/FetchErrorHandeling"
import RefreshIcon from "@mui/icons-material/Refresh"
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge"
import MapView from "../../../../components/MapView/MapView"
import TerminalHealthInstalledApps from "./TerminalHealthInstalledApps"

import Alerts from "../../../../../base/errorHandeling/Alerts"

const TerminalHealth = (props) => {
  const [isReqSent, setIsReqSent] = useState(false)
  const [isRefresh, setIsRefresh] = useState(false)
  // icon state
  const [healthData, setHealthData] = useState([])
  const [lastPowerOnDate, lastPowerOnTime] = String(healthData?.lastPowerOn || "").trim().split(/\s+/)
  const [connectionDet, setConnectionDet] = useState()
  const [availMemPerc, setAvailMemPerc] = useState(0)
  const [availStorPerc, setAvailStorPerc] = useState(0)
  const [completedStorPerc, setCompletedStorperc] = useState(0)
  const [completedMemPerc, setCompletedMemPerc] = useState(0)
  const [isloading, setIsLoading] = useState(false)

  //for success messages
  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessages, setSuccessMessages] = useState([])

  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [isUnauhtError, setIsUnauhtError] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  //clear all alerts after a timeout
  useEffect(() => {
    if ((iserror || isSuccess) === true) {
      let timerId = setTimeout(() => {
        setIserror(false)
        setErrorMessages([])
        setSuccessMessages([])
        setIsSuccess(false)
        timerId = null
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [iserror, isSuccess])

  useEffect(() => {
    api
      .get("/terminals/health/" + props.serialNo)
      .then((res) => {
        setIserror(false)
        setIserrorShow(false)
        setErrorMessages([])
        setIsRefresh(false)
        console.log(res)
        if (res.status === 202) {
          setIsReqSent(true)
        }
      })
      .catch((error) => {
        setIsRefresh(false)
        FetchErrorHandeling(
          error,
          setIserror,
          setErrorMessages,
          setIserrorShow,
          setIsUnauhtError
        )
      })
  }, [props.serialNo, isRefresh])

  let healthConfig = {
    headers: {
      Action: "VIEW_TMNL_HLTH",
      SN: props.serialNo,
    },
  }
  let intervalId

  const getTerminalData = () => {
    setIsLoading(true)
    intervalId = setInterval(() => {
      api
        .get("/terminals/health", healthConfig)
        .then((res) => {
          if (res.data?.description === "No data") {
            console.log("No data")
          }
          if (res.data?.description === "Success") {
            setIsReqSent(false)
            clearInterval(intervalId)
            setHealthData(res.data?.dataList[0].tmnlHealthData)
            setConnectionDet(res.data?.dataList[0].tmnlHealthData?.connection)
            setAvailMemPerc(
              res.data?.dataList[0].tmnlHealthData.memory?.availMemPct
            )
            setAvailStorPerc(
              res.data?.dataList[0].tmnlHealthData.storage?.availStorPct
            )
            console.log(
              completedMemPerc,
              availMemPerc,
              completedStorPerc,
              availStorPerc
            )
            setIsLoading(false)
          }
        })
        .catch((error) => {
          setIsReqSent(false)
          FetchErrorHandeling(
            error,
            setIserror,
            setErrorMessages,
            setIserrorShow,
            setIsUnauhtError
          )
          clearInterval(intervalId)
          setIsLoading(false)
        })
    }, 10000)
  }

  useEffect(() => {
    if (isReqSent === true) {
      getTerminalData()
    }
  }, [isReqSent])

  const handleRefresh = () => {
    setIsRefresh(true)
  }

  // ✅ Reusable Card Wrapper
  const InfoCard = ({ title, icon, height, width, children }) => (
    <Paper
      elevation={4}
      sx={{
        width,
        height,
        p: 2,
        display: "flex",
        flexDirection: "column",
      }}
      className="modalPaper"
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="subtitle1" fontWeight="bold">
          {title}
        </Typography>
        {icon && <img src={icon} alt={title} className="titleImg" />}
      </Stack>
      {children}
    </Paper>
  )

  // ✅ Status Card
  const StatusCard = ({
    healthData,
    activeTerminal,
    inactiveTerminal,
    deviceunlocked,
    devicelock,
  }) => (
    <InfoCard title="Status" height={245} width={300} icon={search}>
      <Stack
        direction="row"
        spacing={7}
        justifyContent="center"
        alignItems="center"
      >
        {/* Device Connection */}
        <Stack alignItems="center">
          <img
            src={
              healthData?.deviceStatus === "ONLINE"
                ? activeTerminal
                : inactiveTerminal
            }
            alt="Connection Status"
            className="terminalHealthStatusImg"
          />
          <Typography
            variant="body2"
            fontWeight="bold"
            color={
              healthData?.deviceStatus === "ONLINE"
                ? "success.main"
                : "error.main"
            }
          >
            {healthData?.deviceStatus || "Unavailable"}
          </Typography>
        </Stack>

        {/* Lock/Unlock */}
        <Stack alignItems="center">
          <img
            src={
              healthData?.lockUnlockStatus === "UNLOCK"
                ? deviceunlocked
                : devicelock
            }
            alt="Lock/Unlock Status"
            className="terminalHealthStatusImg"
          />
          <Typography
            variant="body2"
            fontWeight="bold"
            color={
              healthData?.lockUnlockStatus === "UNLOCK"
                ? "success.main"
                : "error.main"
            }
          >
            {healthData?.lockUnlockStatus || "Unavailable"}
          </Typography>
        </Stack>
      </Stack>
    </InfoCard>
  )

  // ✅ Power Card
  const PowerCard = ({ healthData }) => (
    <InfoCard title="Power" height={245} icon={supply}>
      <Stack
        direction="row"
        spacing={3}
        justifyContent="space-between"
        alignItems="center"
      >
        {/* Battery */}
        <Stack alignItems="center">
          <img
            src={battery}
            alt="battery"
            className="terminalHealthBatteryImg"
          />
          <Typography variant="body2" fontWeight="bold">
            {healthData?.batteryPct || 0}%
          </Typography>
        </Stack>

        {/* Metrics */}
        {[
          {
            icon: switch_1,
            value: healthData?.powerOnOffTimes || 0,
            label: "On/Off Times",
          },
          {
            icon: phone,
            value: healthData?.chargeTimes || 0,
            label: "Charge Cycles",
          },
          {
            icon: time,
            value: healthData?.totRunningTime || "00:00:00",
            label: "Tot. Running Time",
          },
          {
            icon: schedule,
            value: lastPowerOnDate || "0000/00/00",
            secondaryValue: lastPowerOnTime,
            label: "Last Power On",
          },
        ].map(({ icon, value, label, secondaryValue }, idx) => (
          <Stack
            key={idx}
            alignItems="center"
            spacing={0.5}
            className="infoBox"
          >
            <Typography variant="body2" className="iconPara">
              <img src={icon} alt={label} style={{ marginRight: 6 }} />
              {value}
            </Typography>
            {secondaryValue && <Typography variant="body2" sx={{ fontSize: 18, fontWeight: 600, color: "text.secondary", fontVariantNumeric: "tabular-nums" }}>
              {secondaryValue}
            </Typography>}
            <Typography variant="caption" className="titlePara">
              {label}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </InfoCard>
  )

  // ✅ Gauge Card
  const GaugeCard = ({ title, icon, value }) => (
    <InfoCard title={title} icon={icon} height={330} width={330}>
      <Gauge
        value={value}
        startAngle={-110}
        endAngle={110}
        sx={{
          [`& .${gaugeClasses.valueText}`]: {
            fontSize: 28,
            fontWeight: "bold",
          },
        }}
        text={`${value}%`}
      />
    </InfoCard>
  )

  // Connection Card
  const ConnectionCard = ({ title }) => (
    <InfoCard title={title} height={330} icon={connection}>
      <Stack
        sx={{ mt: 2 }}
        direction="row"
        spacing={5}
        justifyContent="space-between"
      >
        <OperatorCard
          title="Primary Operator"
          operatorDet={connectionDet?.primaryOperator}
        />
        <OperatorCard
          title="Secondary Operator"
          operatorDet={connectionDet?.secondaryOperator}
        />
        <WifiCard title="WIFI" wifiDet={connectionDet?.wifi} />
      </Stack>
    </InfoCard>
  )

  const WifiCard = ({ title, wifiDet }) => (
    <InfoCard title={title} icon={wifi} height={250}>
      <Stack
        direction="column"
        spacing={1} // 👈 reduce from 2 to 1 (8px gap)
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{ mt: 0.5 }} // optional fine-tune
      >
        {[
          {
            icon: ipAddress,
            value: wifiDet?.ipAddress || "-",
            label: "IP Address",
          },
          {
            icon: gateway,
            value: wifiDet?.gateway || "-",
            label: "Gateway",
          },
          {
            icon: networking,
            value: wifiDet?.subnetMask || "-",
            label: "Subnet Mask",
          },
          {
            icon: dns,
            value: wifiDet?.dns || "-",
            label: "DNS",
          },
        ].map(({ icon, value, label }, idx) => (
          <Stack
            key={idx}
            direction="row"
            alignItems="center"
            spacing={1}
            className="infoBox"
            sx={{ width: "100%" }}
          >
            <img
              src={icon}
              alt={label}
              style={{ width: 16, height: 16, opacity: 0.8 }}
            />

            {/* Texts */}
            <Stack spacing={0} sx={{ flexGrow: 1 }}>
              <Typography variant="body2" fontWeight="500">
                {value}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {label}
              </Typography>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </InfoCard>
  )

  const OperatorCard = ({ title, operatorDet }) => (
    <InfoCard title={title} icon={operatorInfo} height={250}>
      <Stack
        direction="column"
        spacing={1} // 👈 reduce from 2 to 1 (8px gap)
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{ mt: 0.5 }} // optional fine-tune
      >
        {[
          {
            icon: simName,
            value: operatorDet?.operatorName || "-",
            label: "Operator Name",
          },
          {
            icon: signal,
            value: operatorDet?.connType || "-",
            label: "Con. Type",
          },
          {
            icon: simSerial,
            value: operatorDet?.simSerialNumber || "-",
            label: "Sim Serial",
          },
          {
            icon: ipAddress,
            value: operatorDet?.ipAddress || "-",
            label: "IP Address",
          },
        ].map(({ icon, value, label }, idx) => (
          <Stack
            key={idx}
            direction="row"
            alignItems="center"
            spacing={1}
            className="infoBox"
            sx={{ width: "100%" }}
          >
            <img
              src={icon}
              alt={label}
              style={{ width: 16, height: 16, opacity: 0.8 }}
            />

            {/* Texts */}
            <Stack spacing={0} sx={{ flexGrow: 1 }}>
              <Typography variant="body2" fontWeight="500">
                {value}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {label}
              </Typography>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </InfoCard>
  )

  // ✅ Metrics Card
  const MetricsCard = ({ healthData }) => (
    <InfoCard title="Other Metrics" icon={matrics_1} height={180}>
      <Stack direction="row" spacing={6} justifyContent="space-between">
        {[
          {
            icon: touch,
            value: healthData?.screenClickTimes || 0,
            label: "Screen Clicks",
          },
          {
            icon: usb,
            value: healthData?.usbPlugTimes || 0,
            label: "USB Pluggings",
          },
        ].map(({ icon, value, label }, idx) => (
          <Stack
            key={idx}
            alignItems="center"
            spacing={0.5}
            className="infoBox"
          >
            <Typography variant="body2" className="iconPara">
              <img src={icon} alt={label} style={{ marginRight: 6 }} />
              {value}
            </Typography>
            <Typography variant="caption" className="titlePara">
              {label}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </InfoCard>
  )

  const TerminalGeoLocationCard = ({ healthData }) => (
    <InfoCard
      title="Device Geo Location"
      icon={location}
      height={400}
      width={800}
    >
      <MapView lon={healthData?.longitude} lat={healthData?.latitude} />
    </InfoCard>
  )

  return (
    <div>
      {isloading && <LinearProgress />}

      <DialogContent sx={{ mt: -6, pt: 5 }}>
        {/* Alerts */}
        <Alerts
          iserror={iserror}
          errorMessages={errorMessages}
          isSuccess={isSuccess}
          successMessages={successMessages}
          iserrorShow={iserrorShow}
        />

        {/* Refresh Button */}
        <Stack alignItems="flex-end" mb={2}>
          <IconButton aria-label="refresh" onClick={handleRefresh}>
            <RefreshIcon />
          </IconButton>
        </Stack>

        {/* Status + Power */}
        <Grid2 container spacing={2} mb={3}>
          <Grid2 xs={2}>
            <StatusCard
              healthData={healthData}
              activeTerminal={activeTerminal}
              inactiveTerminal={inactiveTerminal}
              deviceunlocked={deviceunlocked}
              devicelock={devicelock}
            />
          </Grid2>
          <Grid2 xs={10}>
            <PowerCard healthData={healthData} />
          </Grid2>
        </Grid2>

        {/* Connection Details */}
        <Grid2 container spacing={2} mb={3}>
          <Grid2 xs={2}>
            <ConnectionCard title="Connection" />
          </Grid2>
          <Grid2 xs={2.2}>
            <GaugeCard
              title="Available Memory"
              icon={memory}
              value={availMemPerc}
            />
          </Grid2>
          <Grid2 xs={2.2}>
            <GaugeCard
              title="Available Storage"
              icon={storage}
              value={availStorPerc}
            />
          </Grid2>
        </Grid2>

        <Grid2 container spacing={2}>
          {/* Map */}
          <Grid2 xs={3}>
            <TerminalGeoLocationCard healthData={healthData} />
          </Grid2>
          {/* Metrics */}
          <Grid2 xs={3}>
            <MetricsCard healthData={healthData} />
          </Grid2>
        </Grid2>
        <TerminalHealthInstalledApps applications={healthData?.installApps} />
      </DialogContent>

      <DialogActions sx={{ p: "1.25rem" }}>
        <Button onClick={props.onClose} variant="outlined" color="error">
          Cancel
        </Button>
      </DialogActions>
    </div>
  )
}

export default TerminalHealth
